
// import React, { useState } from 'react';
// import './Checkout.css';
// import checkoutimage from '../Images/checkoutimage.jpg';
// import { validateMobileNumber, validateEmail } from '../Utils/Validation';
// import { db } from '../firebase/firebase'; // Firebase configuration file
// import { collection, addDoc } from "firebase/firestore";
// import Loading from '../Loader/Loadering';
// import { NavLink, Link } from 'react-router-dom';
// import { useCart } from '../AddToCart/CartContext';
// import { useNavigate, useParams } from "react-router-dom";
// import Logo from "../Images/HeaderLogo.png";
// import { useAuth } from '../firebase/AuthContext'; // Import useAuth
// import TestCheckout from './TestCheckout';

// export default function Checkout() {
//   const navigate = useNavigate();
//   const { cartItems, removeFromCart } = useCart();
//   const { user } = useAuth(); // Fetch current user from AuthContext

//   const [fullname, setFullname] = useState('');
//   const [email, setEmail] = useState(''); // Form email (manually entered)
//   const [isEmailValid, setIsEmailValid] = useState(true);
//   const [contactNo, setContactNo] = useState('');
//   const [whatsappNo, setWhatsappNo] = useState('');
//   const [city, setCity] = useState('');
//   const [province, setProvince] = useState('');
//   const [shippingAddress, setShippingAddress] = useState('');
//   const [loading, setLoading] = useState(false); // Loader state

//   const handleContactNoChange = (event) => {
//     validateMobileNumber(event.target.value, setContactNo);
//   };

//   const handleWhatsappNoChange = (event) => {
//     validateMobileNumber(event.target.value, setWhatsappNo);
//   };

//   const handleEmailChange = (event) => {
//     validateEmail(event.target.value, setEmail, setIsEmailValid);
//   };

//   const handleNewOrderSubmit = async (e) => {
//     e.preventDefault(); // Prevent page reload on form submit

//     if (!isEmailValid) {
//       alert('Please fix email formatting.');
//       return;
//     }
//     if (!contactNo.startsWith('03') && !contactNo.startsWith('923')) {
//       alert('Invalid contact number. Please start with "03" or "923".');
//       return;
//     }
//     if (!whatsappNo.startsWith('03') && !whatsappNo.startsWith('923')) {
//       alert('Invalid whatsapp number. Please start with "03" or "923".');
//       return;
//     }

//     setLoading(true); // Start loading
//     try {
//       // Prepare the products array with product details
//       const products = cartItems.map(item => ({
//         id: item.id, // Product ID
//         title: item.title,
//         name: item.name,
//         quantity: item.quantity, // Product quantity
//         price: item.price, // Product price
//         imageUrl: item.imageUrl[0], // Product image URL (first image in the array)
//       }));

//       // Firebase Firestore me data save karein
//       await addDoc(collection(db, 'newOrder'), {
//         fullname,
//         email, // Form email (manually entered)
//         loginEmail: user?.email || null, // Logged-in user ka email
//         contactNo,
//         whatsappNo,
//         city,
//         province,
//         shippingAddress,
//         products, // Include the products array
//         timestamp: new Date().toISOString(),
//         readTimestamp: null,
//         userId: user?.uid, // Logged-in user ka ID
//         userName: user?.displayName || null, // Logged-in user ka displayName
//       });

//       alert('Order placed successfully!');

//       // Clear the cart after successful submission
//       cartItems.forEach(item => removeFromCart(item));
//       navigate('/');

//       // Clear form fields after submission
//       setFullname("");
//       setEmail("");
//       setContactNo("");
//       setWhatsappNo("");
//       setCity("");
//       setProvince("");
//       setShippingAddress("");
//     } catch (error) {
//       console.error('Error adding document: ', error);
//       alert('Failed to place the order. Please try again.');
//     } finally {
//       setLoading(false); // Stop loading after submission attempt
//     }
//   };

//   return (
//     <>
//       <div className='background'>
//         <div className='check-out-formside'>
//           <form onSubmit={handleNewOrderSubmit}>
//             <Link to="/" className='checkout-logo-link'>
//               <img src={Logo} alt='error' className='checkout-logo-image' />
//             </Link>
//             <label> Full name </label>
//             <div className="wrapper">
//               <i className="ri-user-3-line"></i>
//               <input
//                 type="text"
//                 name="fullName"
//                 placeholder="John"
//                 value={fullname}
//                 onChange={(e) => setFullname(e.target.value)}
//                 required
//               />
//             </div>

//             <label> Email address (Optional) </label>
//             <div className="wrapper">
//               <i className="ri-mail-line"></i>
//               <input
//                 type='text'
//                 name='email'
//                 placeholder='john123@gmail.com'
//                 value={email} // Form email (manually entered)
//                 onChange={handleEmailChange}
//               />
//             </div>
//             {!isEmailValid && email !== '' && (
//               <div style={{ color: 'red', fontSize: '15px' }}>
//                 Email wrong formatting
//               </div>
//             )}
//             {isEmailValid && email !== '' && (
//               <div style={{ color: 'green', fontSize: '15px' }}>
//                 Excellent
//               </div>
//             )}

//             <label> Contact No. </label>
//             <div className="wrapper">
//               <i className="ri-smartphone-line"></i>
//               <input
//                 type='text'
//                 name='contactNo'
//                 placeholder='0309xxxxxx or 923xxxxxxxxx'
//                 value={contactNo}
//                 onChange={handleContactNoChange}
//                 required
//               />
//             </div>

//             <label> Whatsapp No. (Optional) </label>
//             <div className="wrapper">
//               <i className="ri-whatsapp-line"></i>
//               <input
//                 type='text'
//                 name='whatsappNo'
//                 placeholder='0309xxxxxxx or 923xxxxxxxxx'
//                 value={whatsappNo}
//                 onChange={handleWhatsappNoChange}
//               />
//             </div>

//             <div className='city-province'>
//               <div className="wrapper">
//                 <label> City </label>
//                 <i className="ri-building-line" />
//                 <input
//                   type='text'
//                   name='city'
//                   placeholder='Lahore'
//                   value={city}
//                   onChange={(e) => setCity(e.target.value)}
//                   required
//                 />
//               </div>

//               <div className="wrapper">
//                 <label> Province </label>
//                 <i className="ri-map-2-line" />
//                 <input
//                   type='text'
//                   name='province'
//                   placeholder='Punjab'
//                   value={province}
//                   onChange={(e) => setProvince(e.target.value)}
//                   required
//                 />
//               </div>
//             </div>

//             <label> Shipping address </label>
//             <div className="wrapper">
//               <i className="ri-home-heart-line"></i>
//               <input
//                 type='text'
//                 name='shippingAddress'
//                 placeholder='House No 45, Street 10, Bahria Town Phase 4'
//                 value={shippingAddress}
//                 onChange={(e) => setShippingAddress(e.target.value)}
//                 required
//               />
//             </div>

//             <div className='freeShipping-COD-Container'>
//               <div className='free-shipping'>
//                 <input
//                   type="checkbox"
//                   id="freeShipping"
//                   checked={true}
//                 />
//                 <label>
//                   <i className="ri-bus-2-line"></i>
//                   Free shipping
//                 </label>
//               </div>

//               <div className='cash-on-delivery'>
//                 <input
//                   type="checkbox"
//                   id="cod"
//                   checked={true}
//                 />
//                 <label>
//                   <i className="ri-shake-hands-line"></i>
//                   Cash on delivery
//                 </label>
//               </div>
//             </div>

//             <button type="submit" disabled={loading} style={{ marginTop: '1.5rem' }}>
//               {loading && <Loading />}
//               Complete Order
//             </button>
//           </form>
//           <div className='checkout-copyright'>
//             <p className='checkout-copyright-text'>© 2023, Copyright shopit®. All rights reserved.</p>
//           </div>
//           <div className='checkout-terms-and-conditions-container'>
//             <Link to="/refundpolicy" className='checkout-terms-and-condition-link'>
//               Refund Policy
//             </Link>
//             <Link to="/privcypolicy" className='checkout-terms-and-condition-link'>
//               Privacy Policy
//             </Link>
//             <Link to="/termsofservice" className='checkout-terms-and-condition-link'>
//               Terms of Service
//             </Link>
//             <Link to="/shippingpolicy" className='checkout-terms-and-condition-link'>
//               Shipping Policy
//             </Link>
//             <Link to="/contactinformation" className='checkout-terms-and-condition-link'>
//               Contact Information
//             </Link>
//           </div>
//         </div>

//         <div className='imageside'>
//           <img src={checkoutimage} alt='error' />
//         </div>
//       </div>
//       <TestCheckout/ >
//     </>
//   );
// }




import React, { useState, useEffect } from 'react';
import './Checkout.css';
import checkoutimage from '../Images/checkoutimage.jpg';
import { validateMobileNumber, validateEmail } from '../Utils/Validation';
import { db } from '../firebase/firebase'; // Firebase configuration file
import { collection, addDoc } from "firebase/firestore";
import Loading from '../Loader/Loadering';
import { NavLink, Link } from 'react-router-dom';
import { useCart } from '../AddToCart/CartContext';
import { useNavigate, useParams } from "react-router-dom";
// import Logo from "../Images/HeaderLogo.png";
import { useAuth } from '../firebase/AuthContext'; // Import useAuth
// import TestCheckout from './TestCheckout';
import styles from './Checkout.module.css';
import Logo from "../Images/logo.png";

export default function Checkout() {
  useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
  const navigate = useNavigate();
  const { cartItems, removeFromCart } = useCart();
  const { user } = useAuth(); // Fetch current user from AuthContext

  const [isProductListOpen, setIsProductListOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(true);

  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState(''); // Form email (manually entered)
  const [isEmailValid, setIsEmailValid] = useState(true);
  const [country, setCountry] = useState('Pakistan');
  const [contactNo, setContactNo] = useState('');
  const [whatsappNo, setWhatsappNo] = useState('');
  const [city, setCity] = useState('');
  const [province, setProvince] = useState('');
  const [postelCode, setPostelCode] = useState('');
  const [shippingAddress, setShippingAddress] = useState('');
  const [apartment, setApartment] = useState('');
  const [loading, setLoading] = useState(false); // Loader state

  const handleContactNoChange = (event) => {
    validateMobileNumber(event.target.value, setContactNo);
  };

  const handleWhatsappNoChange = (event) => {
    validateMobileNumber(event.target.value, setWhatsappNo);
  };

  const handleEmailChange = (event) => {
    validateEmail(event.target.value, setEmail, setIsEmailValid);
  };

  const handleNewOrderSubmit = async (e) => {
    e.preventDefault(); // Prevent page reload on form submit

    if (!isEmailValid) {
      alert('Please fix email formatting.');
      return;
    }
    if (!contactNo.startsWith('03') && !contactNo.startsWith('923')) {
      alert('Invalid phone number. Please enter 11 digit number.');
      return;
    }
    // if (!whatsappNo.startsWith('03') && !whatsappNo.startsWith('923')) {
    //   alert('Invalid whatsapp number. Please enter 11 digit number.');
    //   return;
    // }

    setLoading(true); // Start loading
    try {
      // Prepare the products array with product details
      const products = cartItems.map(item => ({
        id: item.id, // Product ID
        title: item.title,
        name: item.name,
        quantity: item.quantity, // Product quantity
        price: item.price, // Product price
        discountPrice: item.discountPrice, // Product discount price
        imageUrl: item.imageUrl[0], // Product image URL (first image in the array)
      }));

      // Firebase Firestore me data save karein
      await addDoc(collection(db, 'newOrder'), {
        fullname,
        email, // Form email (manually entered)
        // loginEmail: user?.email || null, // Logged-in user ka email
        loginEmail: user ? user.email : "Not Logged In", // Agar login hai toh user email, warna "Not Logged In"
        country,
        contactNo,
        whatsappNo,
        city,
        province,
        postelCode,
        shippingAddress,
        apartment,
        products, // Include the products array
        timestamp: new Date().toISOString(),
        readTimestamp: null,
        // userId: user?.uid, // Logged-in user ka ID
        // userName: user?.displayName || null, // Logged-in user ka displayName
        userId: user ? user.uid : "Not Logged In", // Agar login hai toh user ID, warna "Not Logged In"
        userName: user ? user.displayName : "Not Logged In", // Agar login hai toh user ka naam, warna "Not Logged In"
      });

      alert('Order placed successfully!');

      // Clear the cart after successful submission
      cartItems.forEach(item => removeFromCart(item));
      navigate('/');

      // Clear form fields after submission
      setCountry("Pakistan"); 
      setFullname("");
      setEmail("");
      setContactNo("");
      setWhatsappNo("");
      setCity("");
      setProvince("");
      setPostelCode("");
      setShippingAddress("");
      setApartment("");
    } catch (error) {
      console.error('Error adding document: ', error);
      alert('Failed to place the order. Please try again.');
    } finally {
      setLoading(false); // Stop loading after submission attempt
    }
  };

    // Calculate order summary
    const subtotal = cartItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
    const totalItems = cartItems.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <>
      <div className={styles.checkoutHeader}>
        <Link to="/" className={styles.checkoutLogo}>
            <img src={Logo} alt='error' className='checkout-logo-image' />
        </Link>
        <Link to="/cart" className={styles.checkoutCart}>
        <i class="ri-shopping-bag-line" to="/cart" style={{fontSize:'2rem', color:'#046287', cursor:'pointer'}} />
        </Link>
      </div>

      <form onSubmit={handleNewOrderSubmit} className={styles.container}>
        <div className={styles.responsiveSection}>
  <div className={styles.summaryColumn}>
    <div className={styles.responsiveSummaryCard}>
      <div className={styles.responsiveProductListHeader} onClick={() => setIsCollapsed(!isCollapsed)}>
        <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
          <h2 className={styles.summaryTitle} style={{color:'#0579a7'}}>Order summary</h2>
          <i className={`ri-arrow-down-s-line ${styles.arrowIcon} ${isCollapsed ? styles.arrowDown : styles.arrowUp}`} />
        </div>
        {/* <span>{totalItems} {totalItems === 1 ? 'item' : 'items'}</span> */}
        <span style={{color:'#0579a7', fontWeight:'500', fontSize:'large'}}>Rs. {subtotal.toFixed(2)}</span> 
      </div>

      {/* Collapsible content with transitions */}
      <div className={`${styles.collapsibleContent} ${isCollapsed ? styles.collapsed : styles.expanded}`}>
        <div className={styles.productList}>
          {cartItems.map((item, index) => (
            <div key={index} className={styles.productItem}>
              <div className={styles.productImage}>
                {item.imageUrl && item.imageUrl[0] && (
                  <img 
                    src={item.imageUrl[0]} 
                    alt={item.name} 
                    style={{ width: '70px', height: '70px', objectFit: 'fill' }}
                  />
                )}
              </div>
              <div className={styles.productInfo}>
                <div className={styles.productName}>{item.title}</div>
                <div className={styles.productDesc}>Quantity: {item.quantity}</div>
              </div>
              <div className={styles.productPrice}>Rs. {item.price * item.quantity}</div>
            </div>
          ))}
        </div>
        
        <div className={styles.discountSection}>
          <div className={styles.discountInputContainer}>
            <input 
              type="text" 
              placeholder="Discount code" 
              className={styles.discountInput}
            />
            <button className={styles.applyBtn}>Apply</button>
          </div>
          
          <div className={styles.priceBreakdown}>
            <div className={styles.priceRow}>
              <span>Subtotal - {totalItems} {totalItems === 1 ? 'item' : 'items'}</span>
              <span>Rs. {subtotal.toFixed(2)}</span>
            </div>
            <div className={styles.priceRow}>
              <span>Shipping</span>
              <span className={styles.freeShipping}>FREE</span>
            </div>
          </div>
          
          <div className={styles.totalRow}>
            <span>Total</span>
            <span>PKR - Rs. {subtotal.toFixed(2)}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
        {/* -------mobilesection------- */}




        <div className={styles.checkoutGrid}>

          {/* Right Column - Summary (comes first on mobile) */}
          <div className={styles.summaryColumn}>
            <div className={styles.summaryCard}>  
              <div className={styles.productListHeader} onClick={() => setIsProductListOpen(!isProductListOpen)}>
                <h2 className={styles.summaryTitle}>Order summary</h2>
                <div style={{display:'flex', justifyContent:'center', alignItems:'center'}}>
                  {/* <span>{totalItems} {totalItems === 1 ? 'item' : 'items'}</span> */}
                  <span style={{color:'#0579a7'}}>{isProductListOpen ? 'Hide' : 'Show'}</span>
                  <i className={`ri-arrow-down-s-line ${styles.arrowIcon} ${isProductListOpen ? styles.arrowUp : ''}`}></i>
                </div>
              </div>

              {/* Product list with transition */}
    <div className={`${styles.productListWrapper} ${isProductListOpen ? styles.open : ''}`}>
      <div className={styles.productListContainer}>
        <div className={styles.productList}>
          {cartItems.map((item, index) => (
            <div key={index} className={styles.productItem}>
              <div className={styles.productImage}>
                {item.imageUrl && item.imageUrl[0] && (
                  <img 
                    src={item.imageUrl[0]} 
                    alt={item.name} 
                    style={{ width: '70px', height: '70px', objectFit: 'fill' }}
                  />
                )}
              </div>
              <div className={styles.productInfo}>
                <div className={styles.productName}>{item.title}</div>
                <div className={styles.productDesc}>Quantity: {item.quantity}</div>
              </div>
              <div className={styles.productPrice}>Rs. {item.price * item.quantity}</div>
            </div>
          ))}
        </div>
      </div>
    </div>

              <div className={styles.discountSection}>
                <div className={styles.discountInputContainer}>
                  <input 
                    type="text" 
                    placeholder="Discount code" 
                    className={styles.discountInput}
                    // style={{padding:'30px'}}
                  />
                  <button className={styles.applyBtn} disabled>Apply</button>
                </div>
              
                <div className={styles.priceBreakdown}>
                  <div className={styles.priceRow}>
                    <span>Subtotal - {totalItems} {totalItems === 1 ? 'item' : 'items'}</span>
                    <span>Rs. {subtotal.toFixed(2)}</span>
                  </div>
                  <div className={styles.priceRow}>
                    <span>Shipping</span>
                    <span className={styles.freeShipping}>FREE</span>
                  </div>
                </div>
              
                <div className={styles.totalRow}>
                  <span>Total</span>
                  <span>PKR - Rs. {subtotal.toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>


        
        {/* Left Column - Form (becomes second on mobile) */}
        <div className={styles.formColumn}>
          <div style={{display:'flex', justifyContent:'space-between', alignItems:'center'}}>
            <span className={styles.sectionTitle}>Contact</span>
            <Link to='/login' className={styles.sectionTitle} style={{color:'#0579a7',fontSize:'1rem', textUnderlineOffset:'4px'}}>Login</Link>
          </div>
          <div className={styles.card}>
            <input 
              type="text" 
              name='email'
              placeholder="Email - (ای میل)" 
              className={styles.inputFieldLarge}
              value={email}
              onChange={handleEmailChange}
            />
            {!isEmailValid && email !== '' && (
                <div style={{ color: 'red', fontSize: '15px', marginTop: '5px' }}>
                  Email wrong formatting
                </div>
              )}
              {isEmailValid && email !== '' && (
                <div style={{ color: 'green', fontSize: '15px', marginTop: '5px' }}>
                  Excellent
                </div>
              )}
            <div className={styles.checkboxContainer}>
              <input type="checkbox" className={styles.checkbox} />
              <span>Email me with news and offers</span>
            </div>
          </div>
          
          <h1 className={styles.sectionTitle}>Delivery</h1>
          
          <div className={styles.card}>
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Country/Region - (ملک/علاقہ)</label>
              <select className={styles.inputField}
              value={country}
              onChange={(e) => setCountry(e.target.value)}
              required
              >
                <option>Pakistan</option>
              </select>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Full name - (پورا نام)</label>
              <input type="text" className={styles.inputFieldLarge}
              name='fullName' 
              value={fullname}
              onChange={(e) => setFullname(e.target.value)}
              required
              />
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Complete address - (مکمل پتہ)</label>
              <input type="text" className={styles.inputFieldLarge} 
              name='shippingAddress'
              value={shippingAddress}
              onChange={(e) => setShippingAddress(e.target.value)}
              required
              />
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>
                Apartment, suite, etc. <span className={styles.optionalText}>(optional)</span>
              </label>
              <input type="text" className={styles.inputFieldLarge} 
              name='apartment'
              value={apartment}
              onChange={(e) => setApartment(e.target.value)}
              />
            </div>
            
            <div className={styles.twoColumnGrid}>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>City - (شہر)</label>
                <input type="text" className={styles.inputFieldLarge} 
                name='city'
                value={city}
                onChange={(e) => setCity(e.target.value)}
                required
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>Province - (صوبہ)</label>
                <input type="text" className={styles.inputFieldLarge} 
                name='province'
                value={province}
                onChange={(e) => setProvince(e.target.value)}
                required
                />
              </div>
              <div className={styles.formGroup}>
                <label className={styles.formLabel}>
                  Postal code <span className={styles.optionalText}>(optional) </span>
                  - (پوسٹل کوڈ)
                </label>
                <input type="text" className={styles.inputFieldLarge} 
                name='postelCode' 
                value={postelCode}
                onChange={(e) => setPostelCode(e.target.value)}
                />
              </div>
            </div>
            
            <div className={styles.formGroup}>
              <label className={styles.formLabel}>Phone number - (فون نمبر)</label>
              <input type="text" className={styles.inputFieldLarge} 
              name='contactNo'
              // placeholder='0309xxxxxx or 923xxxxxxxxx'
              value={contactNo}
              onChange={handleContactNoChange}
              required
              />
            </div>

            {/* <div className={styles.formGroup}>
              <label className={styles.formLabel}>WhatsApp number<span className={styles.optionalText}>(optional) </span>- (واٹس ایپ نمبر)</label>
              <input type="text" className={styles.inputFieldLarge} 
              name='whatsappNo'
              // placeholder='0309xxxxxxx or 923xxxxxxxxx'
              value={whatsappNo}
              onChange={handleWhatsappNoChange}
              />
            </div> */}
            
            <div className={styles.checkboxContainer}>
              <input type="checkbox" className={styles.checkbox} />
              <span>Save this information for next time</span>
            </div>

            {/* <button type="submit" disabled={loading} style={{ marginTop: '1.5rem' }}>
               {loading && <Loading />}
               Complete Order
            </button> */}
          </div>
          
          <h1 className={styles.sectionTitle}>Shipping method</h1>
          
          <div className={styles.card}>
            <div className={styles.radioOption}>
              <input type="radio" name="shipping" defaultChecked className={styles.radioInput} />
              <div className={styles.radioContent}>
                {/* <div className={styles.radioTitle}>Free Shipping</div> */}
                <span>Free Shipping - Standard</span>
                <span className={styles.freeShipping}>FREE</span>
              </div>
            </div>
          </div>
          
          <h1 className={styles.sectionTitle}>Payment</h1>
          <div className={styles.card}>
            <p className={styles.paymentNote}>All transactions are secure and encrypted.</p>
            
            <div className={styles.paymentOptions}>
              <div className={styles.radioOption}>
                <input type="radio" name="payment" defaultChecked className={styles.radioInput} />
                <span>Cash on Delivery (COD)</span>
              </div>
              <div className={styles.cardRadioOption}>
                <input type="radio" name="payment" disabled className={styles.radioInput} />
                <span>Bank detail</span>
              </div>
            </div>
          </div>

          <h1 className={styles.sectionTitle}>Billing address</h1>
          <div className={styles.card}>
            <div className={styles.billingOptions}>
              <div className={styles.radioOption}>
                <input type="radio" name="billing" defaultChecked className={styles.radioInput} />
                <span>Save as shipping address</span>
              </div>
            </div>
          </div>
          

          {/* ------desktop-------- */}
          <div className={styles.desktopsection}>
          <div className={styles.btn}>
            <button className={styles.completeOrderBtn}
            // onClick={handleNewOrderSubmit}
            type="submit"
            disabled={loading}
            >
              {loading && <Loading />}
              Complete order
            </button>
          </div>
          
          <div className={styles.linksContainer}>
            <div className={styles.linksFlex}>
              {/* <a href="#" className={styles.link}>Refund policy</a> */}
              <Link to="/refundpolicy" className={styles.link}>Refund policy</Link>
              <Link to="/privcypolicy" className={styles.link}>Privacy policy</Link>
              <Link to="/termsofservice" className={styles.link}>Terms of service</Link>
              <Link to="/shippingpolicy" className={styles.link}>Shipping policy</Link>
              <Link to="/contactinformation" className={styles.link}>Contact information</Link>
            </div>
          </div>
          </div>
        </div>
      </div>

         {/* ------Mobile-------- */}
        <div className={styles.responsiveSection}>
         <div className={styles.btn}>
            <button className={styles.completeOrderBtn}
            // onClick={handleNewOrderSubmit}
            type="submit"
            disabled={loading}
            >
              {loading && <Loading />}
              Complete order
            </button>
          </div>
          
          <div className={styles.linksContainer}>
            <div className={styles.linksFlex}>
              {/* <a href="#" className={styles.link}>Refund policy</a> */}
              <Link to="/refundpolicy" className={styles.link}>Refund policy</Link>
              <Link to="/privcypolicy" className={styles.link}>Privacy policy</Link>
              <Link to="/termsofservice" className={styles.link}>Terms of service</Link>
              <Link to="/shippingpolicy" className={styles.link}>Shipping policy</Link>
              <Link to="/contactinformation" className={styles.link}>Contact information</Link>
            </div>
          </div>
        </div>
    </form>
    </>
  );
}